import BaseModule from './BaseModule.js';

class ApiCredential extends BaseModule {
  async paginate({ page, per_page, term }) {
    return await this.get(`back-office/api_credentials`, { params: { page, per_page, term } });
  }

  async fetch(id) {
    return await this.get(`/back-office/api_credentials/${id}`);
  }

  async create(tier) {
    return await this.post(`/back-office/api_credentials`, tier);
  }

  async update(tier) {
    return await this.put(`/back-office/api_credentials/${tier.id}`, tier);
  }

  async remove(id) {
    return await this.delete(`/back-office/api_credentials/${id}`);
  }
}

export default ApiCredential;
